/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_AiInputs */

const en_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Engine`)
};

const de_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Engine`)
};

const fr_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur IA`)
};

const es_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor de IA`)
};

const it_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motore AI`)
};

const nl_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Motor`)
};

const pl_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silnik AI`)
};

const fi_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-moottori`)
};

const da_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-motor`)
};

const sv_dashboard_stat_ai = /** @type {(inputs: Dashboard_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Motor`)
};

/**
* | output |
* | --- |
* | "AI Engine" |
*
* @param {Dashboard_Stat_AiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_ai = /** @type {((inputs?: Dashboard_Stat_AiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_AiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_stat_ai(inputs)
	if (locale === "fr") return fr_dashboard_stat_ai(inputs)
	if (locale === "es") return es_dashboard_stat_ai(inputs)
	if (locale === "it") return it_dashboard_stat_ai(inputs)
	if (locale === "nl") return nl_dashboard_stat_ai(inputs)
	if (locale === "pl") return pl_dashboard_stat_ai(inputs)
	if (locale === "fi") return fi_dashboard_stat_ai(inputs)
	if (locale === "da") return da_dashboard_stat_ai(inputs)
	if (locale === "sv") return sv_dashboard_stat_ai(inputs)
	return en_dashboard_stat_ai(inputs)
});